module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_02_winter-512b13d5004802f4c55767c06cf5a1d5.jpg";